import { useEffect, useState } from "react";
import { X, Search, Check } from "lucide-react";
import { api } from "@/lib/api";
import { TkAvatar } from "./TalkLayout";

export function MemberPicker({ selected, setSelected, exclude = [] }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!q.trim()) { setRows([]); return; }
    const t = setTimeout(() => api.get("/talk/users", { params: { q } }).then((r) => setRows(r.data.users.filter((u) => !exclude.includes(u.user_id)))).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [q]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (u) => setSelected((s) => s.some((x) => x.user_id === u.user_id) ? s.filter((x) => x.user_id !== u.user_id) : [...s, u]);
  return (
    <div>
      {selected.length > 0 && <div className="flex flex-wrap gap-1.5 mb-3">{selected.map((u) => (
        <button key={u.user_id} onClick={() => toggle(u)} className="flex items-center gap-1 bg-[#FF2BD6]/15 text-[#FF2BD6] rounded-full pl-1 pr-2 py-0.5 text-xs font-bold" data-testid={`talk-picked-${u.username}`}><TkAvatar p={u} size={20} />{u.display_name}<X className="w-3 h-3" /></button>
      ))}</div>}
      <div className="flex items-center gap-2 bg-white/5 rounded-full px-4 py-2.5">
        <Search className="w-4 h-4 text-white/40" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search members" className="flex-1 bg-transparent outline-none" data-testid="talk-member-search-input" />
      </div>
      <div className="mt-2 max-h-56 overflow-y-auto">
        {rows.map((u) => {
          const on = selected.some((x) => x.user_id === u.user_id);
          return (
            <button key={u.user_id} onClick={() => toggle(u)} className="w-full flex items-center gap-3 p-2 rounded-2xl hover:bg-white/5 text-left" data-testid={`talk-member-result-${u.username}`}>
              <TkAvatar p={u} size={36} />
              <div className="flex-1 min-w-0"><div className="font-bold truncate text-sm">{u.display_name}</div><div className="text-[11px] mono text-white/50">@{u.username}</div></div>
              <span className={`w-6 h-6 rounded-full flex items-center justify-center ${on ? "bg-[#FF2BD6] text-black" : "border border-white/20"}`}>{on && <Check className="w-4 h-4" />}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export function Sheet({ title, onClose, children, testId }) {
  return (
    <div className="fixed inset-0 z-[60] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center" onClick={onClose}>
      <div className="w-full max-w-md max-h-[88vh] overflow-y-auto bg-[#111119] border border-white/10 rounded-t-3xl sm:rounded-3xl p-5" onClick={(e) => e.stopPropagation()} data-testid={testId}>
        <div className="flex items-center justify-between mb-4">
          <div className="font-heading font-black text-xl">{title}</div>
          <button onClick={onClose} data-testid={`${testId}-close`} aria-label="Close"><X className="w-5 h-5 text-white/50" /></button>
        </div>
        {children}
      </div>
    </div>
  );
}
